import type { NextPage } from "next";
import type { AppProps } from "next/app";
import * as React from "react";

export type NextPageWithLayout<T> = NextPage<T> & {
  getLayout?: (page: React.ReactElement) => React.ReactNode;
};

type AppPropsWithLayout<T = {}> = AppProps & {
  Component: NextPageWithLayout<T>;
};

export default function MyApp({ Component, pageProps }: AppPropsWithLayout) {
  return <Component {...pageProps} />;
}
